interface VendorInvoiceDetailsProps {
  rowData: any;
}

export const VoidedView: React.FC<VendorInvoiceDetailsProps> = ({
  rowData,
}) => {
  const getDescription = (): string => {
    const getMaskedBankAccount = (
      bankAccount: string | undefined
    ): string | null => {
      return bankAccount ? bankAccount.replace(/.(?=.{4})/g, "x") : "N/A";
    };
    function formatDate(date) {
      if (!date) {
        return "N/A";
      }
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [month, day, year].join("/");
    }
    if (rowData?.length === 0) {
      return "Account#: N/A DUE N/A; Service N/A to N/A";
    }

    const autoPayDescription = rowData?.autoPayName
      ? rowData?.autoPayName?.toLowerCase() === "eft"
        ? getMaskedBankAccount(rowData?.bankAccount)
        : `AUTOPAY ${getMaskedBankAccount(rowData?.bankAccount)}`
      : "";
    const accountNumber = rowData?.accountNumber
      ? rowData?.accountNumber
      : "N/A";
    return `Account#: ${accountNumber} ${autoPayDescription} DUE ${formatDate(
      rowData?.duedate
    )}; Service date ${formatDate(rowData?.servicePeriodDate)} to ${formatDate(
      rowData?.billingPeriodEndDate
    )} `;
  };
  return (
    <>
      <div className="grid md:grid-cols-1 lg:grid-cols-3">
        {/* Left fields */}
        <div className="p-2 divide-y">
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Service No. Account:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.accountNumber}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Corporate Office Number:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.storeNumber}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Office Status:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.officeStatus}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Confie Office Name:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.officeName}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Office Address:
            </label>
            <div className="expandedLabelVIP fontExpand ml-2">
              {rowData?.officeStreet} {", "} {rowData?.officeCity} {", "}
              {rowData?.officeStateCode} {rowData?.officeZipcode}
            </div>
            <div className="expandedLabelVIP fontExpand ml-2">
              {rowData?.officeZipcode}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Confie Brand:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.officeBrand}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Amount Paid:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.amountPaid}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Billing Period Start Date:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.servicePeriodDate
                ? rowData?.servicePeriodDate &&
                  new Date(rowData?.servicePeriodDate).toLocaleDateString()
                : ""}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Billing Period End Date:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.billingPeriodEndDate
                ? rowData?.billingPeriodEndDate &&
                  new Date(rowData?.billingPeriodEndDate).toLocaleDateString()
                : ""}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Expense Account:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.expenseAccountDescription}
            </div>
          </div>
        </div>
        {/* end of 1st col */}
        {/* start of 2nd col */}
        <div className="p-2 divide-y">
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Invoice No.:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.invoiceNumber}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Date Capture:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.dateCapture
                ? rowData?.dateCapture &&
                  new Date(rowData?.dateCapture).toLocaleDateString()
                : ""}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Vendor Name:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.vendorName}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Vendor ID:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.vendorCode}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Bill Reference:
            </label>
            <div
              className="col-span-2 expandedDataVIP fontExpand blueAndBold underline cursor-pointer"
              onClick={() => {
                window.open(
                  `https://acumaticastg.confie.com/Main?CompanyID=Admin+Retail&ScreenId=AP301000&DocType=INV&RefNbr=${rowData?.billRefNumber}`,
                  "_blank"
                );
              }}
            >
              {rowData?.billRefNumber}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Payment Reference No.:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.paymentRef}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Bank Reference:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.bankReference}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Bank Reference Date:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.bankReferenceDate
                ? rowData?.bankReferenceDate &&
                  new Date(rowData?.bankReferenceDate).toLocaleDateString()
                : ""}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Bank Account:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.bankAccount
                ? rowData?.bankAccount.replace(/.(?=.{4})/g, "x")
                : null}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Auto Pay:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.autoPayName}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Description:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {getDescription()}
            </div>
          </div>
        </div>
        {/* end of 2nd col */}
        {/* start of 3rd col */}
        <div className="p-2 divide-y">
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Utility Type:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.utilityType}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Branch GL:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.branchGL}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Subaccounts:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.glsubaccounts}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Due Date:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.duedate
                ? rowData?.duedate &&
                  new Date(rowData?.duedate).toLocaleDateString()
                : ""}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Previous Balance Amount:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData.previousBalanceAmount}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Draft Date:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.draftDate
                ? rowData?.draftDate &&
                  new Date(rowData?.draftDate).toLocaleDateString()
                : ""}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Invoice Image:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.invoiceImageAttachment}
            </div>
          </div>

          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Note:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.noteSection}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Created By:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.createdBy}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Created Date:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.createdDate
                ? rowData?.createdDate &&
                  new Date(rowData?.createdDate).toLocaleDateString() +
                    " " +
                    new Date(rowData?.createdDate).toLocaleTimeString(
                      navigator.language,
                      {
                        hour: "2-digit",
                        minute: "2-digit",
                      }
                    )
                : ""}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Modified By:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.modifiedBy}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Modified Date:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.modifiedDate
                ? rowData?.modifiedDate &&
                  new Date(rowData?.modifiedDate).toLocaleDateString() +
                    " " +
                    new Date(rowData?.modifiedDate).toLocaleTimeString(
                      navigator.language,
                      {
                        hour: "2-digit",
                        minute: "2-digit",
                      }
                    )
                : ""}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
